import { QuizSessionFactory } from "./QuizSessionFactory";

export const getQuizSessionId = () => {
  const quizSession = QuizSessionFactory.getInstance();
  return quizSession.getId();
};
